module.exports = __webpack_public_path__ + "img/技术咨询.b24671ab.jpg";